import React from 'react';
import ButtonDeleteFile from '../ButtonDeleteFile';
import EditMetaDataItem from '../../../../common/components/UploadedFile/EditMetaDataItem';
import FilePreviewHandler from '../FilePreviewHandler';
import styles from './styles.module.scss';
import mime from 'mime-types';

const UploadedFileViewDelete = ({
                                  fileName,
                                  shumaId,
                                  ...rest
                                }) => {
  const {
    fileID,
    fileTypeID,
    fileExtension,
    freeID,
    freeText,
    shumaID: shumaIDForFile
  } = rest;

  const fileTypes = [
    1, 3, 4, 5, 6, 7, 27, 28, 29, 30, // step-1
    10, 11, 33, // step-3
    2, 8, //step-4
    12, 13, 14, 15, 16, 22, 23, 24, 25, 32, // step-6
    36, // step-8
    34, 35, //step-12
  ];

  return (
    <div className={styles.modalStringContent}>
      {shumaIDForFile
        && <ButtonDeleteFile
          fileName={fileName}
          fileID={fileID}
        />
      }
      {fileTypes.includes(fileTypeID)
        ? (
          <EditMetaDataItem
            fileTypeID={fileTypeID}
            fileExtension={fileExtension}
            mimeType={mime.lookup(fileExtension)}
            fileID={fileID}
            shumaId={shumaId}
            fileName={fileName}
            onFileDelete={() => {}}
            editFormValues={{freeID, freeText}}
            updateFile={() => {}}
            shumaIDForFile={shumaIDForFile}
          />
        )
        : (
          <FilePreviewHandler {...rest}>
            {({openPreview}) => (
              <div className={styles.fileName} onClick={openPreview}>
                {fileName}
              </div>
            )}
          </FilePreviewHandler>
        )
      }
    </div>
  );
};

export default UploadedFileViewDelete;